import { FilterOptionKeys } from '@griply/types';
import { TFunction } from 'i18next';
import { CheckCalendar } from 'shared/assets/icons';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { FilterDateRangeOption, FilterOptionType } from 'shared/types/filter';
import { WeekDays } from 'shared/types/week-days';

export type Options = {
  t: TFunction;
  dateFormat: DateFormatOptions;
  weekStartsOn: WeekDays;
};

export const createCompletedAtFilter = ({
  t,
  dateFormat,
  weekStartsOn,
}: Options): FilterDateRangeOption => ({
  id: FilterOptionKeys.CompletedAt,
  label: t('context-menus.filtering.task.filters.date.completed-at.title'),
  icon: CheckCalendar,
  type: FilterOptionType.DateRange,
  dateFormat,
  weekStartsOn,
  canReset: true,
  hideUndefinedDateOptions: true,
  hideFuturePresets: true,
});
